module.exports = __webpack_public_path__ + "static/media/plus.4bb4b821.svg";